import { statuses, inProgressStatuses } from './constants';
import { Job } from '../../menu/jobsMenu/types';

export const isJobFinished = (job: Job) =>
  !!job && (job.status === statuses.Success || job.status === statuses.Failed);
export const isJobSucceeded = (job: Job) =>
  !!job && (job.status === statuses.Success);
export const isJobInProgress = (job: Job) =>
  !!job && inProgressStatuses.includes(job.status);

const isNumber = (arg: unknown): arg is number => typeof arg === 'number';

export const getJobProgress = (job: Job) => {
  if (!job || !job.progress) {
    return 0;
  }
  const { progress } = job;

  if (isNumber(progress)) {
    return progress;
  }

  return progress.percentage;
};

export const getJobProgressMessage = (job: Job) => {
  if (job && job.progress && !(typeof job.progress === 'number')) {
    return job.progress.message;
  }
  return '';
};
